import React from "react";
import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import { BankOutlined } from "@ant-design/icons";

import SidebarLogo from "./SidebarLogo";
import CustomScrollbars from "./CustomScrollBar";
import { checkRoles } from "../common";
import menu from "./menu.json";

const SubMenu = Menu.SubMenu;

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { pathname } = useLocation();
  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];

  const getIcon = (icon) => {
    switch (icon) {
      case "BankOutlined":
        return <BankOutlined />;
      default:
        return "icon icon-dasbhoard";
    }
  };

  return (
    <>
      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <CustomScrollbars
        className="gx-layout-sider-scrollbar"
        style={{ height: "100vh" }}
      >
        <Menu
          defaultOpenKeys={[defaultOpenKeys]}
          selectedKeys={[selectedKeys]}
          theme={"dark"}
          mode="inline"
        >
          {menu?.map((item) =>
            item?.subMenus
              ? checkRoles(item?.right) && (
                  <SubMenu
                    key={item?.key}
                    popupClassName={"gx-no-header-submenu-popup"}
                    title={
                      <span>
                        {item?.icon ? (
                          <i className={item?.icon} />
                        ) : (
                          getIcon(item?.antIcon)
                        )}
                        <span>{item?.menu}</span>
                      </span>
                    }
                  >
                    {item?.subMenus?.map((subMenu) => (
                      checkRoles(subMenu?.right) && (
                      <Menu.Item key={subMenu?.key}>
                        <Link to={`${item?.path}${subMenu?.path}`}>
                          {subMenu?.icon ? (
                            <i className={subMenu?.icon} />
                          ) : (
                            getIcon(subMenu?.antIcon)
                          )}
                          <span>{subMenu?.menu}</span>
                        </Link>
                      </Menu.Item>
                      )
                    ))}
                  </SubMenu>
                )
              : checkRoles(item?.right) && (
                  <Menu.Item key={item?.key}>
                    <Link to={item?.path}>
                      {item?.icon ? (
                        <i className={item?.icon} />
                      ) : (
                        getIcon(item?.antIcon)
                      )}
                      <span>{item?.menu}</span>
                    </Link>
                  </Menu.Item>
                )
          )}
        </Menu>
      </CustomScrollbars>
    </>
  );
};

export default SidebarContent;
